"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainAdapter = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const types_1 = require("@shapeshiftoss/types");
const unchained = __importStar(require("@shapeshiftoss/unchained-client"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const types_2 = require("../../types");
const bignumber_1 = require("../../utils/bignumber");
const EvmBaseAdapter_1 = require("../EvmBaseAdapter");
const utils_1 = require("../utils");
const SUPPORTED_CHAIN_IDS = [types_1.KnownChainIds.AvalancheMainnet];
const DEFAULT_CHAIN_ID = types_1.KnownChainIds.AvalancheMainnet;
class ChainAdapter extends EvmBaseAdapter_1.EvmBaseAdapter {
    constructor(args) {
        super({
            chainId: DEFAULT_CHAIN_ID,
            supportedChainIds: SUPPORTED_CHAIN_IDS,
            defaultBIP44Params: ChainAdapter.defaultBIP44Params,
            ...args,
        });
        this.assetId = caip_1.avalancheAssetId;
        this.parser = new unchained.avalanche.TransactionParser({
            chainId: this.chainId,
            rpcUrl: this.rpcUrl,
        });
    }
    getDisplayName() {
        return types_2.ChainAdapterDisplayName.Avalanche;
    }
    getName() {
        const enumIndex = Object.values(types_2.ChainAdapterDisplayName).indexOf(types_2.ChainAdapterDisplayName.Avalanche);
        return Object.keys(types_2.ChainAdapterDisplayName)[enumIndex];
    }
    getType() {
        return types_1.KnownChainIds.AvalancheMainnet;
    }
    getFeeAssetId() {
        return this.assetId;
    }
    async getGasFeeData() {
        const feeData = await this.providers.http.getGasFees();
        const normalizationConstants = {
            fast: (0, bignumber_1.bn)(1.2),
            average: (0, bignumber_1.bn)(1),
            slow: (0, bignumber_1.bn)(0.8),
        };
        const calcFee = (fee, speed) => {
            return (0, bignumber_1.bnOrZero)(fee)
                .times(normalizationConstants[speed])
                .toFixed(0, bignumber_js_1.default.ROUND_CEIL)
                .toString();
        };
        return {
            fast: {
                gasPrice: calcFee(feeData.gasPrice, 'fast'),
                maxFeePerGas: calcFee(feeData.maxFeePerGas, 'fast'),
                maxPriorityFeePerGas: calcFee(feeData.maxPriorityFeePerGas, 'fast'),
            },
            average: {
                gasPrice: calcFee(feeData.gasPrice, 'average'),
                maxFeePerGas: calcFee(feeData.maxFeePerGas, 'average'),
                maxPriorityFeePerGas: calcFee(feeData.maxPriorityFeePerGas, 'average'),
            },
            slow: {
                gasPrice: calcFee(feeData.gasPrice, 'slow'),
                maxFeePerGas: calcFee(feeData.maxFeePerGas, 'slow'),
                maxPriorityFeePerGas: calcFee(feeData.maxPriorityFeePerGas, 'slow'),
            },
        };
    }
    async getFeeData({ to, value, chainSpecific: { contractAddress, from, contractData }, sendMax = false, }) {
        var _a, _b;
        const isErc20Send = !!contractAddress;
        // get the exact send max value for an erc20 send to ensure we have the correct input data when estimating fees
        if (sendMax && isErc20Send) {
            const account = await this.getAccount(from);
            const erc20Balance = (_b = (_a = account.chainSpecific.tokens) === null || _a === void 0 ? void 0 : _a.find((token) => {
                const { assetReference } = (0, caip_1.fromAssetId)(token.assetId);
                return assetReference === contractAddress.toLowerCase();
            })) === null || _b === void 0 ? void 0 : _b.balance;
            if (!erc20Balance)
                throw new Error('no balance');
            value = erc20Balance;
        }
        const data = contractData !== null && contractData !== void 0 ? contractData : (await (0, utils_1.getErc20Data)(to, value, contractAddress));
        const gasLimit = await this.providers.http.estimateGas({
            from,
            to: isErc20Send ? contractAddress : to,
            value: isErc20Send ? '0' : value,
            data,
        });
        const gasResults = await this.getGasFeeData();
        return {
            fast: {
                txFee: (0, bignumber_1.bnOrZero)((0, bignumber_1.bn)(gasResults.fast.gasPrice).times(gasLimit)).toPrecision(),
                chainSpecific: { gasLimit, ...gasResults.fast },
            },
            average: {
                txFee: (0, bignumber_1.bnOrZero)((0, bignumber_1.bn)(gasResults.average.gasPrice).times(gasLimit)).toPrecision(),
                chainSpecific: { gasLimit, ...gasResults.average },
            },
            slow: {
                txFee: (0, bignumber_1.bnOrZero)((0, bignumber_1.bn)(gasResults.slow.gasPrice).times(gasLimit)).toPrecision(),
                chainSpecific: { gasLimit, ...gasResults.slow },
            },
        };
    }
}
exports.ChainAdapter = ChainAdapter;
ChainAdapter.defaultBIP44Params = {
    purpose: 44,
    coinType: Number(caip_1.ASSET_REFERENCE.AvalancheC),
    accountNumber: 0,
};
